import { HelpTooltip } from '@/components/common/HelpTooltip'
import { FieldAnnexMarker } from '../../annexes/components/FieldAnnexMarker'
import type { FieldDefinition } from '../../types'

/**
 * Label nad polem: labelPl + opcjonalny "*" dla pól required + tooltip z helpText
 * + (gdy znamy contractId) FieldAnnexMarker dla pól kiedykolwiek zaaneksowanych
 * + opcjonalny slot (np. FieldVerificationBadge).
 */
export function FieldLabel({
  field,
  contractId,
  slot,
}: {
  field: FieldDefinition
  contractId?: number
  slot?: React.ReactNode
}) {
  return (
    <label
      className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.06em] text-slate-700"
      htmlFor={`field-${field.fieldCode}`}
    >
      <span>{field.labelPl}</span>
      {field.isRequired && <span className="text-rose-500" aria-hidden>*</span>}
      {field.helpText && <HelpTooltip text={field.helpText} />}
      {contractId && <FieldAnnexMarker contractId={contractId} fieldCode={field.fieldCode} />}
      {slot}
    </label>
  )
}
